import detectPlatform from "@helpers/detectPlatform"
import { QRCodeSVG } from "qrcode.react"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

export default function GooglePlayAndAppStoreBadgeLinks() {
  const { t } = useTranslation()
  const platform = useMemo(() => detectPlatform(), [])
  const downloadUrl = useMemo(() => `${window.location.origin}/download`, [])

  if (platform === "ios" || platform === "android") {
    const storeUrl =
      platform === "ios"
        ? (import.meta.env.VITE_APP_URL_APPLE_APP_STORE as string)
        : (import.meta.env.VITE_APP_URL_GOOGLE_PLAY_STORE as string)

    return (
      <div className="flex justify-center">
        <Link
          className="rounded-xl bg-white px-6 py-3 text-sm font-semibold text-black transition-opacity hover:opacity-80"
          target="_blank"
          to={storeUrl}
        >
          {t("shared.downloadApp")}
        </Link>
      </div>
    )
  }

  return (
    <div className="flex flex-col items-center gap-3">
      <div className="rounded-2xl bg-white p-3">
        <QRCodeSVG value={downloadUrl} size={140} />
      </div>
      <p className="text-text-secondary text-xs">
        {t("shared.scanToDownload")}
      </p>
    </div>
  )
}
